import React, { useMemo, useState, useEffect, useCallback, useReducer } from 'react';

import {
	XhrStatus,
	Dialog,
	TranslatedString
} from '@bosch/bt-ui';

import './RestfulCallLoading.css';
import withErrorHandler from './ErrorHandler';
import CenterLoadingContainer from './CenterLoadingContainer';

const RestfulCallLoading = (props) => {
	const {
		status
    } = props;

	return (
		<div id="restful-call-loading">
		{
			status === XhrStatus.InProgress ?
				<Dialog
					htmlAttributes={{
						className: 'run-ajax-modal'
					}}
					focusTrapped={false}
					title={<TranslatedString stringId="dialog-info" />}
					// Can be either "error", "warning", "success", "info", or "none"
					alertType="info"
				>
					<h1 className="font-large">
						<TranslatedString stringId="restfull-call-loading" />
					</h1>	
					<CenterLoadingContainer />
				</Dialog>
			:
				<div></div>
		} 
		</div>
	);
}

export default withErrorHandler(RestfulCallLoading);